import { render, staticRenderFns } from "./createTaskDialog.vue?vue&type=template&id=fae00958"
import script from "./createTaskDialog.vue?vue&type=script&lang=js"
export * from "./createTaskDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports